import { createFileRoute } from "@tanstack/react-router";
import PsychotherapySupportsMentalWellnessPage from "@/pages/articles/PsychotherapySupportsMentalWellnessPage";
export const Route = createFileRoute("/psychotherapy-supports-mental-wellness")(
  {
    component: RouteComponent,
    head() {
      return {
        meta: [
          {
            title: "Psychotherapy Supports Mental Wellness | Neuro Wellness",
          },
          {
            name: "description",
            content:
              "Explore how psychotherapy builds emotional resilience, prevents relapse, and complements interventional treatments like TMS for lasting mental wellness.",
          },
          {
            property: "og:title",
            content: "Psychotherapy Supports Mental Wellness | Neuro Wellness",
          },
          {
            property: "og:description",
            content:
              "Explore how psychotherapy builds emotional resilience, prevents relapse, and complements interventional treatments like TMS for lasting mental wellness.",
          },
          {
            property: "og:url",
            content:
              "https://neurowellnesstms.com/psychotherapy-supports-mental-wellness",
          },
          {
            property: "og:type",
            content: "website",
          },
          {
            name: "twitter:card",
            content: "summary_large_image",
          },
        ],
        links: [
          {
            rel: "canonical",
            href: "https://neurowellnesstms.com/psychotherapy-supports-mental-wellness",
          },
        ],
      };
    },
  },
);
function RouteComponent() {
  return <PsychotherapySupportsMentalWellnessPage />;
}
